/**
 * Management of the state in sessionStorage for Intelligent Bookseller
 */
const STORAGE_KEY = 'intelligent-bookseller-state';

/**
 * Save the state in sessionStorage
 * @param {Object} questionnaire - The questionnaire data
 * @param {Object|null} apiResponse - The API response
 * @param {boolean} quizSubmitted - The quiz submission state
 */
export function saveState(questionnaire, apiResponse, quizSubmitted) {
  try {
    const stateToSave = {
      questionnaire,
      apiResponse: apiResponse || null,
      quizSubmitted,
      timestamp: new Date().toISOString()
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
  } catch (error) {
    console.error('Error saving state:', error);
  }
}

/**
 * Load the state from sessionStorage
 * @returns {Object|null} The saved state or null if not found
 */
export function loadState() {
  try {
    const savedState = sessionStorage.getItem(STORAGE_KEY);
    if (!savedState) {
      return null;
    }
    return JSON.parse(savedState);
  } catch (error) {
    console.error('Error loading state:', error);
    return null;
  }
}

/**
 * Clear the state from sessionStorage
 */
export function clearState() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing state:', error);
  }
}
